<template>
  <div class="bg-white">
    <div class="relative overflow-hidden">
      <Popover as="header" class="relative">
        <div class="bg-gray-900 pt-6">
          <nav
            class="relative mx-auto flex justify-between px-4 sm:px-6"
            aria-label="Global"
          >
            <div class="flex flex-1 justify-between">
              <div class="flex justify-between w-full md:w-auto">
                <img class="h-32 w-auto" src="images/logo.png" alt="" />
                <div class="-mr-2 flex md:hidden">
                  <PopoverButton
                    class="
                      bg-gray-900
                      rounded-md
                      p-2
                      inline-flex
                      items-center
                      justify-center
                      text-gray-400
                      hover:bg-gray-800
                      focus:outline-none
                      focus:ring-2
                      focus-ring-inset
                      focus:ring-white
                    "
                  >
                    <MenuIcon class="h-6 w-6" aria-hidden="true" />
                  </PopoverButton>
                </div>
              </div>
              <div class="hidden space-x-8 md:flex">
                <a
                  v-for="item in navigation"
                  :key="item.name"
                  :href="item.href"
                  class="text-base font-medium text-white hover:text-gray-300"
                  >{{ item.name }}</a
                >
              </div>
              <div class="hidden md:flex md:space-x-6">
                <Link
                  :href="route('dashboard.index')"
                  class="text-base font-medium text-white hover:text-gray-300"
                >
                  Administrar
                </Link>
              </div>
            </div>
          </nav>
        </div>

        <transition
          enter-active-class="duration-150 ease-out"
          enter-from-class="opacity-0 scale-95"
          enter-to-class="opacity-100 scale-100"
          leave-active-class="duration-100 ease-in"
          leave-from-class="opacity-100 scale-100"
          leave-to-class="opacity-0 scale-95"
        >
          <PopoverPanel
            focus
            class="
              absolute
              top-0
              inset-x-0
              p-2
              transition
              transform
              origin-top
              md:hidden
            "
          >
            <div
              class="
                rounded-lg
                shadow-md
                bg-white
                ring-1 ring-black ring-opacity-5
                overflow-hidden
              "
            >
              <div class="px-5 pt-4 flex items-center justify-between">
                <div>
                  <img
                    class="h-8 w-auto"
                    src="https://tailwindui.com/img/logos/workflow-mark-teal-500-cyan-600.svg"
                    alt=""
                  />
                </div>
                <div class="-mr-2">
                  <PopoverButton
                    class="
                      bg-white
                      rounded-md
                      p-2
                      inline-flex
                      items-center
                      justify-center
                      text-gray-400
                      hover:bg-gray-100
                      focus:outline-none
                      focus:ring-2
                      focus:ring-inset
                      focus:ring-cyan-600
                    "
                  >
                    <XIcon class="h-6 w-6" aria-hidden="true" />
                  </PopoverButton>
                </div>
              </div>
              <div class="pt-5 pb-6">
                <div class="px-2 space-y-1">
                  <a
                    v-for="item in navigation"
                    :key="item.name"
                    :href="item.href"
                    class="
                      block
                      px-3
                      py-2
                      rounded-md
                      text-base
                      font-medium
                      text-gray-900
                      hover:bg-gray-50
                    "
                    >{{ item.name }}</a
                  >
                </div>
                <div class="mt-6 px-5">
                  <Link
                    :href="route('dashboard.index')"
                    class="text-base font-medium text-gray-900 hover:underline"
                  >
                    Administrar
                  </Link>
                </div>
              </div>
            </div>
          </PopoverPanel>
        </transition>
      </Popover>
      <main>
        <div
          class="pt-10 bg-gray-900 sm:pt-16 lg:pt-8 lg:pb-14 lg:overflow-hidden"
        >
          <div class="mx-auto">
            <div class="lg:grid lg:grid-cols-2 lg:gap-8">
              <div
                class="
                  mx-auto
                  max-w-md
                  px-4
                  sm:max-w-2xl sm:px-6 sm:text-center
                  lg:px-0 lg:text-left lg:flex lg:items-center
                "
              >
                <div class="lg:py-24">
                  <h1
                    class="
                      mt-4
                      text-4xl
                      tracking-tight
                      font-extrabold
                      text-white
                      sm:mt-5 sm:text-6xl
                      lg:mt-6
                      xl:text-6xl
                    "
                  >
                    <span class="block">{{ t("main_title") }}</span>
                    <span
                      class="
                        bg-clip-text
                        text-transparent
                        bg-gradient-to-r
                        from-light-blue-400
                        to-green-400
                        block
                      "
                      >{{ t("experience_years") }}</span
                    >
                  </h1>
                  <p
                    class="
                      mt-3
                      text-base text-gray-300
                      sm:mt-5 sm:text-xl
                      lg:text-lg
                      xl:text-xl
                    "
                  >
                    {{ t("main_description") }}
                  </p>
                  <div class="mt-10 sm:mt-12">
                    <div class="sm:flex">
                      <div class="mt-3 sm:mt-0">
                        <a href="#contact">
                          <button
                            type="button"
                            class="
                              block
                              w-full
                              py-3
                              px-4
                              rounded-md
                              shadow
                              bg-gradient-to-r
                              from-green-500
                              to-light-blue-600
                              text-white
                              font-medium
                              hover:from-green-600 hover:to-light-blue-700
                              focus:outline-none
                              focus:ring-2
                              focus:ring-offset-2
                              focus:ring-light-blue-400
                              focus:ring-offset-gray-900
                            "
                          >
                            {{ t("contact_us") }}
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-12 -mb-16 sm:-mb-48 lg:m-0 lg:relative">
                <div
                  class="
                    mx-auto
                    max-w-md
                    px-4
                    sm:max-w-2xl sm:px-6
                    lg:max-w-none lg:px-0
                  "
                >
                  <!-- Illustration taken from Lucid Illustrations: https://lucid.pixsellz.io/ -->
                  <img
                    class="
                      w-full
                      lg:absolute
                      lg:inset-y-0
                      lg:left-0
                      lg:h-full
                      lg:w-auto
                      lg:max-w-none
                    "
                    src="images/banner.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Feature section with grid -->
        <div id="who-we-are" class="relative bg-white py-16 sm:py-24 lg:py-32">
          <div
            class="
              mx-auto
              max-w-md
              px-4
              text-center
              sm:max-w-3xl sm:px-6
              lg:px-8 lg:max-w-7xl
            "
          >
            <h2
              class="
                text-base
                font-semibold
                tracking-wider
                text-cyan-600
                uppercase
              "
            >
              {{ t("who_we_are") }}
            </h2>
            <p
              class="
                mt-2
                text-3xl
                font-extrabold
                text-gray-900
                tracking-tight
                sm:text-4xl
              "
            >
              {{ t("who_we_are_experience") }}
            </p>
            <p class="mt-5 max-w-prose mx-auto text-xl text-gray-500">
              {{ t("who_we_are_description") }}
            </p>
            <div class="mt-12">
              <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                <div
                  v-for="feature in features"
                  :key="feature.name"
                  class="pt-6"
                >
                  <div class="flow-root bg-gray-50 rounded-lg px-6 pb-8">
                    <div class="-mt-6">
                      <div>
                        <span
                          class="
                            inline-flex
                            items-center
                            justify-center
                            p-3
                            bg-gradient-to-tr
                            from-green-400
                            to-light-blue-600
                            rounded-md
                            shadow-lg
                          "
                        >
                          <component
                            :is="feature.icon"
                            class="h-6 w-6 text-white"
                            aria-hidden="true"
                          />
                        </span>
                      </div>
                      <h3
                        class="
                          mt-8
                          text-lg
                          font-medium
                          text-gray-900
                          tracking-tight
                        "
                      >
                        {{ feature.name }}
                      </h3>
                      <p class="mt-5 text-base text-gray-500">
                        {{ feature.description }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Testimonial section -->
        <div
          class="
            pb-16
            bg-gradient-to-r
            from-green-400
            to-light-blue-600
            lg:pb-0 lg:z-10 lg:relative
          "
        >
          <div
            class="
              lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-3 lg:gap-8
            "
          >
            <div class="relative lg:-my-8">
              <div
                aria-hidden="true"
                class="absolute inset-x-0 top-0 h-1/2 bg-white lg:hidden"
              />
              <div
                class="
                  mx-auto
                  max-w-md
                  px-4
                  sm:max-w-3xl sm:px-6
                  lg:p-0 lg:h-full
                "
              >
                <div
                  class="
                    aspect-w-10 aspect-h-6
                    rounded-xl
                    shadow-xl
                    overflow-hidden
                    sm:aspect-w-16 sm:aspect-h-7
                    lg:aspect-none lg:h-full
                  "
                >
                  <img
                    class="object-cover lg:h-full lg:w-full"
                    src="https://images.unsplash.com/photo-1520333789090-1afc82db536a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2102&q=80"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="mt-12 lg:m-0 lg:col-span-2 lg:pl-8">
              <div
                class="
                  mx-auto
                  max-w-md
                  px-4
                  sm:max-w-2xl sm:px-6
                  lg:px-0 lg:py-20 lg:max-w-none
                "
              >
                <blockquote>
                  <div>
                    <svg
                      class="h-12 w-12 text-white opacity-25"
                      fill="currentColor"
                      viewBox="0 0 32 32"
                      aria-hidden="true"
                    >
                      <path
                        d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"
                      />
                    </svg>
                    <p class="mt-6 text-2xl font-medium text-white">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Sed urna nulla vitae laoreet augue. Amet feugiat est
                      integer dolor auctor adipiscing nunc urna, sit.
                    </p>
                  </div>
                  <footer class="mt-6">
                    <p class="text-base font-medium text-white">Judith Black</p>
                    <p class="text-base font-medium text-cyan-100">
                      CEO at PureInsights
                    </p>
                  </footer>
                </blockquote>
              </div>
            </div>
          </div>
        </div>

        <div
          id="services"
          class="relative bg-white pt-16 pb-32 overflow-hidden"
        >
          <div
            class="
              mx-auto
              max-w-md
              px-4
              text-center
              sm:max-w-3xl sm:px-6
              lg:px-8 lg:max-w-7xl
              mb-12
            "
          >
            <h2
              class="
                text-base
                font-semibold
                tracking-wider
                text-cyan-600
                uppercase
              "
            >
              {{ t("services") }}
            </h2>
            <p
              class="
                mt-2
                text-3xl
                font-extrabold
                text-gray-900
                tracking-tight
                sm:text-4xl
              "
            >
              {{ t("services_title") }}
            </p>
            <p class="mt-5 max-w-prose mx-auto text-xl text-gray-500">
              {{ t("services_description") }}
            </p>
          </div>
          <div id="consulting" class="relative">
            <div
              class="
                lg:mx-auto
                lg:max-w-7xl
                lg:px-8
                lg:grid
                lg:grid-cols-2
                lg:grid-flow-col-dense
                lg:gap-24
              "
            >
              <div
                class="
                  px-4
                  max-w-xl
                  mx-auto
                  sm:px-6
                  lg:py-16 lg:max-w-none lg:mx-0 lg:px-0
                "
              >
                <div>
                  <div>
                    <span
                      class="
                        h-12
                        w-12
                        rounded-md
                        flex
                        items-center
                        justify-center
                        bg-light-blue-600
                      "
                    >
                      <SparklesIcon
                        class="h-6 w-6 text-white"
                        aria-hidden="true"
                      />
                    </span>
                  </div>
                  <div class="mt-6">
                    <h2
                      class="
                        text-3xl
                        font-extrabold
                        tracking-tight
                        text-gray-900
                      "
                    >
                      {{ t("consulting") }}
                    </h2>
                    <p class="mt-4 text-lg text-gray-500">
                      {{ t("consulting_first_description") }}
                    </p>

                    <ul class="my-4 ml-5 text-lg text-gray-500">
                      <li v-for="element in consulting" :key="element.text">
                        {{ element.text }}
                      </li>
                    </ul>

                    <p class="mt-4 text-lg text-gray-500">
                      {{ t("consulting_second_description") }}
                    </p>
                    <div class="mt-6">
                      <a
                        href="#contact"
                        class="
                          inline-flex
                          px-4
                          py-2
                          border border-transparent
                          text-base
                          font-medium
                          rounded-md
                          shadow-sm
                          text-white
                          bg-light-blue-600
                          hover:bg-light-blue-700
                        "
                      >
                        {{ t("contact_us") }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-12 sm:mt-16 lg:mt-0">
                <div
                  class="
                    pl-4
                    -mr-48
                    sm:pl-6
                    md:-mr-16
                    lg:px-0 lg:m-0 lg:relative lg:h-full
                  "
                >
                  <img
                    class="
                      w-full
                      lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none
                    "
                    src="images/gestionentrenamiento.png"
                    alt="Inbox user interface"
                  />
                </div>
              </div>
            </div>
          </div>
          <div id="physic" class="mt-24">
            <div
              class="
                lg:mx-auto
                lg:max-w-7xl
                lg:px-8
                lg:grid
                lg:grid-cols-2
                lg:grid-flow-col-dense
                lg:gap-24
              "
            >
              <div
                class="
                  px-4
                  max-w-xl
                  mx-auto
                  sm:px-6
                  lg:py-32 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-2
                "
              >
                <div>
                  <div>
                    <span
                      class="
                        h-12
                        w-12
                        rounded-md
                        flex
                        items-center
                        justify-center
                        bg-light-blue-600
                      "
                    >
                      <LightningBoltIcon
                        class="h-6 w-6 text-white"
                        aria-hidden="true"
                      />
                    </span>
                  </div>
                  <div class="mt-6">
                    <h2
                      class="
                        text-3xl
                        font-extrabold
                        tracking-tight
                        text-gray-900
                      "
                    >
                      {{ t("physic_title") }}
                    </h2>
                    <p class="mt-4 text-lg text-gray-500">
                      {{ t("physic_description") }}
                    </p>
                    <ul class="mt-4 ml-5 text-lg text-gray-500">
                      <li>
                        NOM-011-STPS-2001 –
                        {{ t("noice") }}
                      </li>
                      <li>
                        NOM-015-STPS-2001 –
                        {{ t("temperature") }}
                      </li>
                      <li>
                        NOM-024-STPS-2001 –
                        {{ t("vibrations") }}
                      </li>
                      <li>
                        NOM-025-STPS-2008 –
                        {{ t("illumination") }}
                      </li>
                      <li>
                        NOM-022-STPS-2015 –
                        {{ t("lands") }}
                      </li>
                    </ul>
                    <div class="mt-6">
                      <a
                        href="#contact"
                        class="
                          inline-flex
                          px-4
                          py-2
                          border border-transparent
                          text-base
                          font-medium
                          rounded-md
                          shadow-sm
                          text-white
                          bg-light-blue-600
                          hover:bg-light-blue-700
                        "
                      >
                        {{ t("contact_us") }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-12 sm:mt-16 lg:mt-0 lg:col-start-1">
                <div
                  class="
                    pr-4
                    -ml-48
                    sm:pr-6
                    md:-ml-16
                    lg:px-0 lg:m-0 lg:relative lg:h-full
                  "
                >
                  <img
                    class="
                      w-full
                      lg:absolute lg:right-0 lg:h-full lg:w-auto lg:max-w-none
                    "
                    src="images/fuentesfijas.png"
                    alt="Customer profile user interface"
                  />
                </div>
              </div>
            </div>
          </div>
          <div id="chemic" class="relative">
            <div
              class="
                lg:mx-auto
                lg:max-w-7xl
                lg:px-8
                lg:grid
                lg:grid-cols-2
                lg:grid-flow-col-dense
                lg:gap-24
              "
            >
              <div
                class="
                  px-4
                  max-w-xl
                  mx-auto
                  sm:px-6
                  lg:py-16 lg:max-w-none lg:mx-0 lg:px-0
                "
              >
                <div>
                  <div>
                    <span
                      class="
                        h-12
                        w-12
                        rounded-md
                        flex
                        items-center
                        justify-center
                        bg-light-blue-600
                      "
                    >
                      <BeakerIcon
                        class="h-6 w-6 text-white"
                        aria-hidden="true"
                      />
                    </span>
                  </div>
                  <div class="mt-6">
                    <h2
                      class="
                        text-3xl
                        font-extrabold
                        tracking-tight
                        text-gray-900
                      "
                    >
                      {{ t("chemic_title") }}
                    </h2>
                    <p class="mt-4 text-lg text-gray-500">
                      {{ t("chemic_first_description") }}
                    </p>
                    <ul class="my-4 ml-5 text-lg text-gray-500">
                      <li v-for="element in chemic" :key="element.text">
                        {{ element.text }}
                      </li>
                    </ul>
                    <p class="mt-4 text-lg text-gray-500">
                      {{ t("chemic_second_description") }}
                    </p>
                    <p class="mt-4 text-md text-gray-500">
                      {{ t("chemic_link_text") }}
                      <a href="" class="underline">
                        {{ t("chemic_link") }}
                      </a>
                    </p>
                    <div class="mt-6">
                      <a
                        href="#contact"
                        class="
                          inline-flex
                          px-4
                          py-2
                          border border-transparent
                          text-base
                          font-medium
                          rounded-md
                          shadow-sm
                          text-white
                          bg-light-blue-600
                          hover:bg-light-blue-700
                        "
                      >
                        {{ t("contact_us") }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-12 sm:mt-16 lg:mt-0">
                <div
                  class="
                    pl-4
                    -mr-48
                    sm:pl-6
                    md:-mr-16
                    lg:px-0 lg:m-0 lg:relative lg:h-full
                  "
                >
                  <img
                    class="
                      w-full
                      lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none
                    "
                    src="images/quimicos.png"
                    alt="quimicos"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Blog section -->
        <div id="resources" class="relative bg-gray-50 py-16 sm:py-24 lg:py-32">
          <div class="relative">
            <div
              class="
                text-center
                mx-auto
                max-w-md
                px-4
                sm:max-w-3xl sm:px-6
                lg:px-8 lg:max-w-7xl
              "
            >
              <h2
                class="
                  text-base
                  font-semibold
                  tracking-wider
                  text-cyan-600
                  uppercase
                "
              >
                Aprendizaje
              </h2>
              <p
                class="
                  mt-2
                  text-3xl
                  font-extrabold
                  text-gray-900
                  tracking-tight
                  sm:text-4xl
                "
              >
                Recursos de ayuda
              </p>
              <p class="mt-5 mx-auto max-w-prose text-xl text-gray-500">
                Te invitamos a explorar nuestros artículos de información que
                consideramos importante para la industria.
              </p>
            </div>
            <div
              class="
                mt-12
                mx-auto
                max-w-md
                px-4
                grid
                gap-8
                sm:max-w-lg sm:px-6
                lg:px-8 lg:grid-cols-3 lg:max-w-7xl
              "
            >
              <div
                v-for="post in blogPosts"
                :key="post.id"
                class="flex flex-col rounded-lg shadow-lg overflow-hidden"
              >
                <div class="flex-shrink-0">
                  <img
                    class="h-48 w-full object-cover"
                    :src="post.imageUrl"
                    alt=""
                  />
                </div>
                <div class="flex-1 bg-white p-6 flex flex-col justify-between">
                  <div class="flex-1">
                    <p class="text-sm font-medium text-cyan-600">
                      <a :href="post.category.href" class="hover:underline">
                        {{ post.category.name }}
                      </a>
                    </p>
                    <a :href="post.href" class="block mt-2">
                      <p class="text-xl font-semibold text-gray-900">
                        {{ post.title }}
                      </p>
                      <p class="mt-3 text-base text-gray-500">
                        {{ post.preview }}
                      </p>
                    </a>
                  </div>
                  <div class="mt-6 flex items-center">
                    <div class="flex-shrink-0">
                      <a :href="post.author.href">
                        <img
                          class="h-10 w-10 rounded-full"
                          :src="post.author.imageUrl"
                          :alt="post.author.name"
                        />
                      </a>
                    </div>
                    <div class="ml-3">
                      <p class="text-sm font-medium text-gray-900">
                        <a :href="post.author.href" class="hover:underline">
                          {{ post.author.name }}
                        </a>
                      </p>
                      <div class="flex space-x-1 text-sm text-gray-500">
                        <time :datetime="post.datetime">
                          {{ post.date }}
                        </time>
                        <span aria-hidden="true"> &middot; </span>
                        <span>
                          lectura de
                          {{ post.readingLength }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CTA Section -->
        <div id="contact" class="bg-gray-100">
          <div class="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
            <div class="relative bg-white shadow-xl">
              <div class="grid grid-cols-1 lg:grid-cols-3">
                <!-- Contact information -->
                <div
                  class="
                    relative
                    overflow-hidden
                    py-10
                    px-6
                    bg-light-blue-700
                    sm:px-10
                    xl:p-12
                  "
                >
                  <div
                    class="absolute inset-0 pointer-events-none sm:hidden"
                    aria-hidden="true"
                  >
                    <svg
                      class="absolute inset-0 w-full h-full"
                      width="343"
                      height="388"
                      viewBox="0 0 343 388"
                      fill="none"
                      preserveAspectRatio="xMidYMid slice"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M-99 461.107L608.107-246l707.103 707.107-707.103 707.103L-99 461.107z"
                        fill="url(#linear1)"
                        fill-opacity=".1"
                      />
                      <defs>
                        <linearGradient
                          id="linear1"
                          x1="254.553"
                          y1="107.554"
                          x2="961.66"
                          y2="814.66"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#fff" />
                          <stop offset="1" stop-color="#fff" stop-opacity="0" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <div
                    class="
                      hidden
                      absolute
                      top-0
                      right-0
                      bottom-0
                      w-1/2
                      pointer-events-none
                      sm:block
                      lg:hidden
                    "
                    aria-hidden="true"
                  >
                    <svg
                      class="absolute inset-0 w-full h-full"
                      width="359"
                      height="339"
                      viewBox="0 0 359 339"
                      fill="none"
                      preserveAspectRatio="xMidYMid slice"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M-161 382.107L546.107-325l707.103 707.107-707.103 707.103L-161 382.107z"
                        fill="url(#linear2)"
                        fill-opacity=".1"
                      />
                      <defs>
                        <linearGradient
                          id="linear2"
                          x1="192.553"
                          y1="28.553"
                          x2="899.66"
                          y2="735.66"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#fff" />
                          <stop offset="1" stop-color="#fff" stop-opacity="0" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <div
                    class="
                      hidden
                      absolute
                      top-0
                      right-0
                      bottom-0
                      w-1/2
                      pointer-events-none
                      lg:block
                    "
                    aria-hidden="true"
                  >
                    <svg
                      class="absolute inset-0 w-full h-full"
                      width="160"
                      height="678"
                      viewBox="0 0 160 678"
                      fill="none"
                      preserveAspectRatio="xMidYMid slice"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M-161 679.107L546.107-28l707.103 707.107-707.103 707.103L-161 679.107z"
                        fill="url(#linear3)"
                        fill-opacity=".1"
                      />
                      <defs>
                        <linearGradient
                          id="linear3"
                          x1="192.553"
                          y1="325.553"
                          x2="899.66"
                          y2="1032.66"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#fff" />
                          <stop offset="1" stop-color="#fff" stop-opacity="0" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <h3 class="text-lg font-medium text-white">
                    {{ t("contact_title") }}
                  </h3>
                  <p class="mt-6 text-base text-light-blue-50 max-w-3xl">
                    {{ t("contact_description") }}
                  </p>
                  <dl class="mt-8 space-y-6">
                    <dd class="flex text-base text-light-blue-50">
                      <PhoneIcon
                        class="flex-shrink-0 w-6 h-6 text-light-blue-200"
                        aria-hidden="true"
                      />
                      <span class="ml-3">+52 (555) 740-3073</span>
                    </dd>

                    <dd class="flex text-base text-light-blue-50">
                      <PhoneIcon
                        class="flex-shrink-0 w-6 h-6 text-light-blue-200"
                        aria-hidden="true"
                      />
                      <span class="ml-3">+52 (555) 740-9540</span>
                    </dd>
                    <dd class="flex text-base text-light-blue-50">
                      <PhoneIcon
                        class="flex-shrink-0 w-6 h-6 text-light-blue-200"
                        aria-hidden="true"
                      />
                      <span class="ml-3">+52 (555) 740-9611</span>
                    </dd>
                    <dd class="flex text-base text-light-blue-50">
                      <MailIcon
                        class="flex-shrink-0 w-6 h-6 text-light-blue-200"
                        aria-hidden="true"
                      />
                      <span class="ml-3">contacto@analisisambiental.com</span>
                    </dd>
                    <dd class="flex text-base text-light-blue-50">
                      <LocationMarkerIcon
                        class="flex-shrink-0 w-6 h-6 text-light-blue-200"
                        aria-hidden="true"
                      />
                      <div class="ml-3">
                        <p>Asturias 22, Álamos</p>
                        <p>Benito Juárez, 03400</p>
                        <p>Ciudad de México, CDMX</p>
                      </div>
                    </dd>
                  </dl>
                </div>

                <!-- Contact form -->
                <div class="py-10 px-6 sm:px-10 lg:col-span-2 xl:p-12">
                  <h3 class="text-lg font-medium text-gray-900">
                    {{ t("send_us_a_message") }}
                  </h3>
                  <form
                    action="#"
                    method="POST"
                    class="
                      mt-6
                      grid grid-cols-1
                      gap-y-6
                      sm:grid-cols-2 sm:gap-x-8
                    "
                  >
                    <div>
                      <ui-input
                        :label="t('first_name')"
                        type="text"
                        autocomplete="given-name"
                      >
                      </ui-input>
                    </div>
                    <div>
                      <ui-input
                        :label="t('last_name')"
                        type="text"
                        autocomplete="family-name"
                      >
                      </ui-input>
                    </div>
                    <div>
                      <ui-input
                        :label="t('email')"
                        type="email"
                        autocomplete="email"
                      >
                      </ui-input>
                    </div>
                    <div>
                      <ui-input
                        :label="t('phone')"
                        type="text"
                        autocomplete="tel"
                        :cornerHint="t('optional')"
                      >
                      </ui-input>
                    </div>
                    <div>
                      <ui-input :label="t('business')" type="text"> </ui-input>
                    </div>
                    <div class="sm:col-span-2">
                      <ui-input :label="t('subject')" type="text"> </ui-input>
                    </div>
                    <div class="sm:col-span-2">
                      <ui-textarea :label="t('message')" rows="4">
                      </ui-textarea>
                    </div>
                    <div class="sm:col-span-2 sm:flex sm:justify-end">
                      <ui-button class="mt-2">
                        {{ t("send") }}
                      </ui-button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <footer class="bg-gray-50" aria-labelledby="footerHeading">
        <h2 id="footerHeading" class="sr-only">Footer</h2>
        <div
          class="
            max-w-md
            mx-auto
            pt-12
            px-4
            sm:max-w-7xl sm:px-6
            lg:pt-16 lg:px-8
          "
        >
          <div class="xl:grid xl:grid-cols-3 xl:gap-8">
            <div class="space-y-8 xl:col-span-1">
              <img class="h-20" src="/images/logo.png" alt="Company name" />
              <p class="text-gray-500 text-base">
                {{ t("footer_description") }}
              </p>
            </div>
            <div class="mt-12 grid grid-cols-2 gap-8 xl:mt-0 xl:col-span-2">
              <div class="md:grid md:grid-cols-2 md:gap-8">
                <div>
                  <h3
                    class="
                      text-sm
                      font-semibold
                      text-gray-400
                      tracking-wider
                      uppercase
                    "
                  >
                    {{ t("services") }}
                  </h3>
                  <ul class="mt-4 space-y-4">
                    <li
                      v-for="item in footerNavigation.solutions"
                      :key="item.name"
                    >
                      <a
                        :href="item.href"
                        class="text-base text-gray-500 hover:text-gray-900"
                      >
                        {{ item.name }}
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="mt-12 md:mt-0">
                  <h3
                    class="
                      text-sm
                      font-semibold
                      text-gray-400
                      tracking-wider
                      uppercase
                    "
                  >
                    {{ t("quick_links") }}
                  </h3>
                  <ul class="mt-4 space-y-4">
                    <li
                      v-for="item in footerNavigation.support"
                      :key="item.name"
                    >
                      <a
                        :href="item.href"
                        class="text-base text-gray-500 hover:text-gray-900"
                      >
                        {{ item.name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="md:grid md:grid-cols-2 md:gap-8">
                <div class="mt-12 md:mt-0">
                  <h3
                    class="
                      text-sm
                      font-semibold
                      text-gray-400
                      tracking-wider
                      uppercase
                    "
                  >
                    {{ t("legal") }}
                  </h3>
                  <ul class="mt-4 space-y-4">
                    <li v-for="item in footerNavigation.legal" :key="item.name">
                      <a
                        :href="item.href"
                        class="text-base text-gray-500 hover:text-gray-900"
                      >
                        {{ item.name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-12 border-t border-gray-200 py-8">
            <p class="text-base text-gray-400 xl:text-center">
              {{
                t("copyright", {
                  year: new Date().getFullYear(),
                })
              }}
            </p>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { defineComponent, h } from "vue";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
import {
  InboxIcon,
  BeakerIcon,
  SparklesIcon,
  CloudUploadIcon,
  CogIcon,
  LockClosedIcon,
  MenuIcon,
  RefreshIcon,
  ServerIcon,
  ShieldCheckIcon,
  XIcon,
  MailIcon,
  PhoneIcon,
  LocationMarkerIcon,
  AnnotationIcon,
  GlobeAltIcon,
  LightningBoltIcon,
  ScaleIcon,
  CheckCircleIcon,
  SearchIcon,
} from "@heroicons/vue/outline";
import { ChevronRightIcon, ExternalLinkIcon } from "@heroicons/vue/solid";
import { useI18n } from "vue-i18n";

const navigation = [
  { name: "¿Quiénes somos?", href: "#who-we-are" },
  { name: "Servicios", href: "#services" },
  { name: "Recursos de ayuda", href: "#resources" },
  { name: "Contacto", href: "#contact" },
];

const consulting = [
  { text: "Principios Básicos de Higiene Industrial," },
  { text: "Conservación de la Audición," },
  { text: "Protección Respiratoria," },
  { text: "Sistemas de Comunicación de Riesgos (GHS)," },
  { text: "Estrategias de Muestreo," },
  { text: "Principios de Ventilación, etc." },
];

const chemic = [
  { text: "Gravimetría" },
  { text: "Cromatografía de gases-FID" },
  { text: "Absorción Atómica" },
  { text: "Electrodo de Ion Selectivo" },
  { text: "Espectofotometría de Fluorescencia" },
  { text: "Volumetría" },
  { text: "Espectofotometría UV-VIS" },
  { text: "Sensor Electroquímico" },
];

const features = [
  {
    name: "Valores",
    description:
      "Creemos en la Integridad, en la Honestidad y Ética para realizar negocios. Nuestros servicios están basados en nuestro Profesionalismo, Conocimiento Técnico y Experiencia de nuestro equipo. Nuestra filosofía de trabajo está basada en Innovación, Compromiso y Calidad hacia nuestros clientes.",
    icon: CheckCircleIcon,
  },
  {
    name: "Experiencia profesional",
    description:
      "Nuestro equipo de trabajo, cuenta con más de 40 años de experiencia en la práctica de la Higiene Industrial. Nuestros 30 años en el mercado respaldan nuestro trabajo.",
    icon: CheckCircleIcon,
  },
  {
    name: "Constante crecimiento",
    description:
      "Invertimos en las mejores tecnologías e instrumentos innovadores para realizar nuestras evaluaciones. Constantemente nuestro personal está a la vanguardia de las normativas en Higiene Industrial.",
    icon: CheckCircleIcon,
  },
];
const blogPosts = [
  {
    id: 1,
    title: "Entrenamiento especializado",
    href: "#",
    date: "Mar 16, 2020",
    datetime: "2020-03-16",
    category: { name: "Artículo", href: "#" },
    imageUrl: "/images/entrenamiento.jpeg",
    preview:
      "Ofrecemos cursos especializados en Higiene Industrial, como: Principios Básicos de Higiene Industrial, Conservación de la Audición, Protección Respiratoria, Sistemas de comunicación de riesgos (GHS), Estrategias de muestreo, Principios de Ventilación, etc.",
    author: {
      name: "David Rodríguez",
      imageUrl:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
      href: "#",
    },
    readingLength: "6 min",
  },
  {
    id: 2,
    title: "Monitoreos de agentes físicos",
    href: "#",
    date: "Mar 10, 2020",
    datetime: "2020-03-10",
    category: { name: "Artículo", href: "#" },
    imageUrl: "/images/fisicos.jpeg",
    preview:
      "Ruido, ruido perimetral, vibraciones humanas, condiciones térmicas elevadas y abatidas, radiaciones U.V. y electromagnéticas de baja frecuencia, iluminación, etc.",
    author: {
      name: "David Rodríguez",
      imageUrl:
        "https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
      href: "#",
    },
    readingLength: "4 min",
  },
  {
    id: 3,
    title: "Monitoreo y análisis de agentes químicos",
    href: "#",
    date: "Feb 12, 2020",
    datetime: "2020-02-12",
    category: { name: "Artículo", href: "#" },
    imageUrl: "/images/quimicos.jpeg",
    preview:
      "Polvos molestos, compuestos orgánicos volátiles, neblinas de aceite, neblinas ácidas, neblinas básicas, gases, humos de soldadura, de acuerdo a la NOM-010-STPS-2014.",
    author: {
      name: "David Rodríguez",
      imageUrl:
        "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
      href: "#",
    },
    readingLength: "11 min",
  },
];
const footerNavigation = {
  solutions: [
    { name: "Gestión y Entrenamiento Especializado", href: "#consulting" },
    { name: "Monitoreo Agentes Físicos", href: "#physic" },
    { name: "Monitoreo de Agentes Químicos ", href: "#chemic" },
  ],
  support: [
    { name: "Contacto", href: "#contact" },
    { name: "¿Quiénes somos?", href: "#who-we-are" },
    { name: "Recursos de ayuda", href: "#resources" },
  ],
  legal: [
    { name: "Aviso de privacidad", href: "/privacidad.pdf" },
    { name: "Términos y condiciones", href: "#" },
    {
      name: "Política de confidencialidad",
      href: "/confidencialidad.pdf",
    },
  ],
};

export default {
  components: {
    Popover,
    PopoverButton,
    PopoverPanel,
    ChevronRightIcon,
    ExternalLinkIcon,
    MenuIcon,
    XIcon,
    MailIcon,
    PhoneIcon,
    LocationMarkerIcon,
    AnnotationIcon,
    GlobeAltIcon,
    LightningBoltIcon,
    ScaleIcon,
    CheckCircleIcon,
    InboxIcon,
    SparklesIcon,
    SearchIcon,
    BeakerIcon,
  },
  setup() {
    const { t } = useI18n();

    return {
      t,
      navigation,
      features,
      consulting,
      chemic,
      blogPosts,
      footerNavigation,
    };
  },
};
</script>

<i18n>
{
  "es": {
    "main_title": "Laboratorio de Higiene Industrial",
    "experience_years": "con 30 años de experiencia",
    "main_description": "Somos un Laboratorio Acreditado ante la EMA y aprobado por la STPS en materia de ambiente laboral.",
    "contact_title": "Información de contacto",
    "contact_description": "Para nosotros es importante estar en contacto con ustedes. Si tienen alguna duda o comentario, estamos a sus órdenes.",
    "send_us_a_message": "Envíanos un mensaje",
    "first_name": "Nombre",
    "last_name": "Apellidos",
    "email": "Correo electrónico",
    "phone": "Teléfono",
    "subject": "Asunto",
    "business": "Empresa",
    "message": "Mensaje",
    "optional": "opcional",
    "send": "Enviar",
    "contact_us": "Contáctanos",
    "who_we_are": "¿Quiénes somos?",
    "who_we_are_experience": "La experiencia nos respalda",
    "who_we_are_description": "Contamos con más de 30 años de experiencia, personal profesional y calificado para ofrecer servicios de calidad en Higiene Industrial.",
    "services": "Servicios de gestión",
    "services_title": "Tenemos los mejores servicios para ti",
    "services_description": "Te presentamos de forma breve algunos de los servicios que ofrecemos a nuestros clientes siempre garantizando resultados precisos y a tiempo.",
    "consulting": "Gestión y Entrenamiento Especializado",
    "consulting_first_description": "Nuestro equipo de trabajo está formado por especialistas en Higiene Industrial con experiencia internacional. Ofrecemos gestión de programas especializados en Higiene Industrial. Ofrecemos cursos especializados en materia de Higiene Industrial, como:",
    "consulting_second_description": "Ventilación, etc. Así mismo, ofrecemos servicios de consultoría especializada para orientar a las empresas en el cumplimiento corporativo y normativo en materia de Higiene Industrial y Salud ocupacional.",
    "physic_title": "Monitoreo de Agentes Físicos",
    "physic_description": "Estamos acreditados (EMA) y aprobados (STPS) para realizar monitoreos en las siguientes normas:",
    "noice": "Ruido",
    "temperature": "Temperaturas extremas y abatidas",
    "vibrations": "Vibraciones humanas",
    "illumination": "Iluminación",
    "lands": "Tierras Físicas",
    "chemic_title": "Monitoreo de Agentes Químicos",
    "chemic_first_description": "Estamos acreditados (EMA) y aprobados (STPS) para realizar monitoreos y análisis de acuerdo con la NOM -010-STPS 2014 . Tenemos acreditados los siguientes métodos analíticos:",
    "chemic_second_description": "Contamos con 46 métodos analiticos aprobados por la STPS para cuantificar 108 sustancias con valor límite de exposición. (NOM-010-STPS-2014 Apéndice 1)",
    "chemic_link_text": "Consulta nuestra",
    "chemic_link": "ACREDITACIÓN Y APROBACIÓN",
    "footer_description": "Laboratorio de pruebas con más de 30 años de experiencia",
    "services": "Servicios",
    "quick_links": "Enlaces rápidos",
    "legal": "Legal",
    "copyright": "©{year} Análisis Ambiental. Todos los derechos reservados"
  }
}
</i18n>
